import { mergeStyles, PrimaryButton } from 'office-ui-fabric-react';
import * as React from 'react';

import { FormFieldV2, FormV2 } from '../../../models/safDiagnostic.models';
import { IImmutableMap } from '../../../state/redux';
import { IStyledComponent, styledComponent } from '../../../theme/styledComponent';
import { ICommonStyles, IConnectedComponentProps } from '../../../types';
import { truncateWithEllipsis } from '../../../utils';
import { isFormInvalid } from '../../../utils/safDiagnosticSchema';

import { getCommonClassNames, getCommonStyles, getFormBtnStyles } from './common.styles';
import { Checkbox, DatePicker, Dropdown, TextField } from './FormFields';

interface IFormSchemaProps {
  formSchema: IImmutableMap<FormV2>;
  submitBtnLabel: string;
  formComponentReducer: (
    componentKey: string,
    updatedModel: string | number | boolean | Date | null | undefined
  ) => void;
  formSubmitReducer: () => void;
}

type IFormBuilderProps = IFormSchemaProps & IStyledComponent<ICommonStyles> & IConnectedComponentProps;

export class FormBuilderC extends React.PureComponent<IFormBuilderProps> {
  private commonClassNames = getCommonClassNames(this.props.styles, {
    theme: this.props.theme,
    stylesFunc: this.props.stylesFunc
  });
  // tslint:disable-next-line no-any
  private mapper: { [index: string]: any } = {
    CheckBox: Checkbox,
    DatePicker: DatePicker,
    DropDown: Dropdown,
    TextField: TextField
  };

  public render(): React.ReactNode {
    const key = this.props.formSchema.get('Key');

    const formFields = this.props.formSchema.get('FormFields');
    let forms;
    if (formFields && formFields.size > 0) {
      forms = formFields.map((formProp: IImmutableMap<FormFieldV2>, index: number) => {
        return this._formBuilder(formProp, index);
      });
    }
    return (
      <div key={key}>
        <div className={mergeStyles(this.commonClassNames.contentContainer, this.commonClassNames.title)}>
          {this.props.formSchema.get('LocalizedTitle')}
        </div>
        {this.props.formSchema.get('LocalizedDescription') && (
          <div className={this.commonClassNames.contentContainer}>
            {this.props.formSchema.get('LocalizedDescription')}
          </div>
        )}
        {forms}
        <div className={this.commonClassNames.contentContainer}>
          <PrimaryButton
            data-automation-id={`submit-btn-${this.props.submitBtnLabel}`}
            styles={getFormBtnStyles({ theme: this.props.theme, stylesFunc: this.props.stylesFunc })}
            title={this.props.submitBtnLabel}
            text={truncateWithEllipsis(this.props.submitBtnLabel, 62)}
            primary={true}
            disabled={isFormInvalid(this.props.formSchema)}
            onClick={this._onClick}
          />
        </div>
      </div>
    );
  }

  private _formBuilder = (formProp: IImmutableMap<FormFieldV2>, index: number): React.ReactNode | null => {
    const FormComponent = this.mapper[formProp.get('Type')];
    if (!FormComponent) {
      return null;
    }

    const key = `formComponent_${formProp.get('Key')}_${index}`;
    return (
      <div key={key} className={this.commonClassNames.contentContainer}>
        <FormComponent
          stylesFunc={this.props.stylesFunc}
          callbackHandlers={this.props.callbackHandlers}
          componentModel={formProp}
          onChangeReducer={this.props.formComponentReducer}
        />
      </div>
    );
  };

  private _onClick = () => {
    if (this.props.formSubmitReducer) {
      this.props.formSubmitReducer();
    }
  };
}

export const FormBuilder = styledComponent(FormBuilderC, getCommonStyles);
